<climb-auth-container>
    <h1>Logging in with Okta...</h1>
    <div>
        <a data-automation-id="return-to-login-link"
           routerLink="/login">
        Return to Login
        </a>
    </div>
</climb-auth-container>
